import React, { useEffect, useState } from 'react';
import { TextField } from '@mui/material';
import {
  formatIsoDateForDisplay,
  normalizeDateInputDisplay,
  parseDateInputToIso,
} from '../utils/dateInput.js';

function DateInputField({
  value,
  onChange,
  onBlur,
  onFocus,
  inputProps,
  placeholder = 'TT.MM.JJJJ',
  InputLabelProps,
  ...textFieldProps
}) {
  const [displayValue, setDisplayValue] = useState(formatIsoDateForDisplay(value));

  useEffect(() => {
    setDisplayValue(formatIsoDateForDisplay(value));
  }, [value]);

  const handleChange = (event) => {
    const nextRawValue = event.target.value;
    const nextDisplayValue = normalizeDateInputDisplay(nextRawValue);
    setDisplayValue(nextDisplayValue);

    if (!String(nextRawValue || '').trim()) {
      onChange?.('');
      return;
    }

    const nextIsoDate = parseDateInputToIso(nextRawValue);
    if (nextIsoDate) {
      onChange?.(nextIsoDate);
    }
  };

  const handleBlur = (event) => {
    const parsedIsoDate = parseDateInputToIso(displayValue);

    if (parsedIsoDate) {
      const normalizedDisplayValue = formatIsoDateForDisplay(parsedIsoDate);
      if (displayValue !== normalizedDisplayValue) {
        setDisplayValue(normalizedDisplayValue);
      }
      onChange?.(parsedIsoDate);
    } else if (String(displayValue || '').trim()) {
      setDisplayValue('');
      onChange?.('');
    } else {
      onChange?.('');
    }

    onBlur?.(event);
  };

  const handleFocus = (event) => {
    event.target.select();
    onFocus?.(event);
  };

  return (
    <TextField
      {...textFieldProps}
      type="text"
      value={displayValue}
      onChange={handleChange}
      onBlur={handleBlur}
      onFocus={handleFocus}
      placeholder={placeholder}
      InputLabelProps={{ shrink: true, ...(InputLabelProps || {}) }}
      inputProps={{
        inputMode: 'numeric',
        autoComplete: 'off',
        ...inputProps,
      }}
    />
  );
}

export default DateInputField;